import {
    Stack,
    Link,
    Box,
    Flex,
    Grid,
    Heading,
    Text,
    Center,
    Divider,
    Button,
} from "@chakra-ui/react";
import * as React from "react";
import { signIn, signOut, useSession } from "next-auth/client";
import NextLink from "next/link";
import { AccountSwitcher } from "components/account";
import { NavLink } from "../navbar/nav-link";
import { NavButton } from "../navbar/nav-button";
import { useRouter } from "next/dist/client/router";
import * as analytics from "utils/analytics";

import { Logo } from "components/logo";
import { LinkShare } from "components/tweets-public/linkShare";

export const Footer = ({ id, url, title, description, disableMenu = false,
    paths,
    disableTweetHunterPush = false,
    disableShare = false,
    titleCollections = "More Collections",
    titleResources = "More Resources",
    source = "tweets",
}) => {


    // paths = extraStaticPages.concat(paths);

    let collections = paths.filter(x => !x.params.isResource);
    // let resources = paths.filter(x => x.params.isResource).concat(extraStaticPages);
    let resources = paths.filter(x => x.params.isResource);

    // console.log(JSON.stringify(collections));

    // to create sitemap
    // let allPosts = collections.concat(resources);
    // allPosts.forEach(path => {
    //     console.log(`<url><loc>${path?.params?.link || (path.params.isResource ? "https://tweethunter.io/resources/" : "https://tweethunter.io/tweets/") + (path.params.slug ?? path.params.id)}</loc></url>`)
    // });

    return (

        <Flex flexDir="column" mt={10} gap={5}>

            {
                !disableShare && (
                    <Box mt={10}>
                        <LinkShare position="center" url={url} title={title + " - " + description} />
                    </Box>
                )
            }

            {
                !disableTweetHunterPush && (
                    <Center flexDir={"column"}>
                        <Divider maxW="200px" mt={10} />
                        <Heading mt={10} fontSize="2xl">Want to drive more opportunities from X?</Heading>
                        <Text mt={2} fontSize="md">Content Inspiration, AI, scheduling, automation, analytics, CRM.</Text>
                        <Text mt={2} fontSize="md">Get all of that and more in Tweet Hunter.</Text>
                        <Button
                            mt={5}
                            borderRadius={"xl"}
                            bg={"gray.800"}
                            color={"white"}
                            as="a"
                            target="_blank"
                            href={`https://tweethunter.io/?utm_source=${source}`}
                            onClick={() => {
                                analytics.log("hit_try_TH", { idPage: id });
                            }}
                        >
                            <Text mr={3}>Try Tweet Hunter for free</Text>
                        </Button>
                        <Divider maxW="200px" mt={10} />
                    </Center>
                )
            }

            <Link mt={10} fontSize="2xl" fontWeight="800" href="/tweets">
                {titleCollections}
            </Link>
            <Grid
                mt={5}
                templateColumns={{ lg: "repeat(3, 1fr)", md: "repeat(1, 1fr)" }}
                gap={3}
            >
                {
                    collections.filter(x => !x?.params?.isCopy).map((page, index) => (
                        <Box key={index} >
                            <Link href={page.params.link ?? (page.params.isResource ? "https://tweethunter.io/resources/" : "https://tweethunter.io/tweets/") + page.params.id} >
                                {page.params.title ?? (page.params.search ? ("Best tweets " + (page.params.search?.includes("@") ? "from " : "about ") + page.params.search) : page.params.id)}
                                {/* {page.params.title} */}
                            </Link>
                        </Box>
                    ))
                }
            </Grid>
            <Link mt={10} fontSize="2xl" fontWeight="800" href="/resources">
                {titleResources}
            </Link>
            <Grid
                mt={5}
                templateColumns={{ lg: "repeat(2, 1fr)", md: "repeat(1, 1fr)" }}
                gap={3}
            >
                {
                    resources.filter(x => !x?.params?.isCopy).map((page, index) => (
                        <Box key={index} >
                            <Link href={page.params.link}  >
                                <Text noOfLines={1} wordBreak="break-all" maxW={{ base: "90vw", md: "400px" }}>{page.params.title ?? ("Best tweets " + (page.params.search?.includes("@") ? "from " : "about ") + page.params.search)}</Text>
                            </Link>
                        </Box>
                    ))
                }
            </Grid>
        </Flex>
    );
};
